import { FlowSpec } from '@digibee/flow';

import {
  flowSpecToCanvasStores,
  useCanvasStore,
  useComponentConfigStore,
  useTrackStore
} from '..';

export const updateStoresFromFlowSpec = (flowSpec: FlowSpec) => {
  const { nodes, edges, configurations, tracks } =
    flowSpecToCanvasStores(flowSpec);

  useCanvasStore.setState({ nodes, edges });
  useComponentConfigStore.setState({ configurations });
  useTrackStore.setState({ tracks });
};
